import React from "react";
import Homepage from "./Homepage";
import Ispirazione from "./Ispirazione";
import Finitura from "./Finitura";
import ColoriFormati from "./ColoriFormati";
import Collezione from "./Collezione";
import Dettagli from "./Dettagli";
import Scaglie from "./Scaglie";
import Gallery from "./Gallery";
import Footer from "./Footer";
import { Provider } from "react-redux";
import { store } from "./app/store";
import Cta from "./Cta";
import FormPage from "./FormPage";
import EfficientCursor from "react-efficient-cursor";
import cursorWrap from "./images/cursor/cursorWrapper.svg";
import cursorPoint from "./images/cursor/cursorPoint.svg";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import styles from './App.module.sass'
import { appConfig } from './configuration'

export default function App() {
  return (
    <div className="app" style={{ cursor: "none !important" }}>
      <Provider store={store}>
        <div className={styles.bg}>
          <video autoPlay loop playsInline muted>
              <source src={appConfig.bg}/>
          </video>
        </div>
        <EfficientCursor speed={0.8} style={{ cursor: "none" }}>
          <img className="cursor" src={cursorPoint} alt="cursor" />
        </EfficientCursor>
        <EfficientCursor speed={0.8}>
          <img className="cursor" src={cursorWrap} alt="cursor" />
        </EfficientCursor>
        <div className={styles.body}>
          <Homepage />
          <Ispirazione />
          <Finitura />
          <Dettagli />
          <Scaglie />
          <Gallery /> 
          <ColoriFormati />
          <Collezione />
        </div>
      </Provider>
    </div>
  );
}
